export type BaseShellViewMode = 'full' | 'clean' | 'minimal' | 'sidebar';

export type ShellViewModeNoHeaderInfoSuffix = '-noheaderinfo';

export type ShellViewMode = BaseShellViewMode | `${BaseShellViewMode}${ShellViewModeNoHeaderInfoSuffix}`;

export const BASE_SHELL_VIEW_MODES: BaseShellViewMode[] = ['full', 'clean', 'minimal', 'sidebar'];

export const NO_HEADER_INFO_SUFFIX: ShellViewModeNoHeaderInfoSuffix = '-noheaderinfo';

export const ALL_SHELL_VIEW_MODES: ShellViewMode[] = [
  ...BASE_SHELL_VIEW_MODES,
  ...BASE_SHELL_VIEW_MODES.map((m) => `${m}${NO_HEADER_INFO_SUFFIX}` as ShellViewMode),
];

export function getBaseShellViewMode(mode: ShellViewMode): BaseShellViewMode {
  return (
    mode.endsWith(NO_HEADER_INFO_SUFFIX) ? mode.slice(0, -NO_HEADER_INFO_SUFFIX.length) : mode
  ) as BaseShellViewMode;
}

export function hasNoHeaderInfo(mode: ShellViewMode): boolean {
  return mode.endsWith(NO_HEADER_INFO_SUFFIX);
}
